import { ICreateGameCategoryState } from './createGameCategoryContext';
import { CreateGameCategoryActionTypes, TCreateGameCategoryAction } from './createGameCategoryActions';

export const createGameCategoryReducer = (
	state: ICreateGameCategoryState,
	action: TCreateGameCategoryAction,
): ICreateGameCategoryState => {
	switch (action.type) {
		case CreateGameCategoryActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case CreateGameCategoryActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case CreateGameCategoryActionTypes.SET_FETCHED_LANGUAGES:
			return {
				...state,
				fetchedLanguages: action.payload.languages,
			};
		case CreateGameCategoryActionTypes.SET_IDs_LANGUAGES:
			return {
				...state,
				IDsSelectedLanguages: action.payload.IDsLanguages,
			};
		case CreateGameCategoryActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.data,
			};
		case CreateGameCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateGameCategoryActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.translationTab,
			};
		case CreateGameCategoryActionTypes.SET_TRANSLATION_FIELDS:
			return {
				...state,
				translations: action.payload.updatedTranslations,
			};
		case CreateGameCategoryActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.updatedTranslations,
			};
		case CreateGameCategoryActionTypes.RESET_FIELDS:
			return {
				...state,
				name: '',
				IDsSelectedLanguages: [],
				dataForSubmit: null,
				translations: [],
			};
		default:
			return state;
	}
};
